module.exports = __webpack_public_path__ + "img/ic_imessages.d8126b16.png";